import type { ConnectionSummary } from '@debtbot/shared';
import { t as dict } from '../i18n';
import { fullName, primaryBalance } from './format';

/** Фильтр списка на главной: owed — мне должны, owe — я должен. */
export type BalanceFilter = 'owed' | 'owe';

export function isBalanceFilter(v: string | null): v is BalanceFilter {
  return v === 'owed' || v === 'owe';
}

/** Имя собеседника для списка и поиска. */
export function peerDisplayName(c: ConnectionSummary): string {
  return c.peer.is_deleted ? dict().home.deletedUser : fullName(c.peer);
}

/** Фильтр по знаку основного баланса (тот же, что показан в строке) и подстроке имени. */
export function filterConnections(
  items: ConnectionSummary[],
  {
    filter,
    query,
  }: {
    filter: BalanceFilter | null;
    query: string;
  },
): ConnectionSummary[] {
  const q = query.trim().toLocaleLowerCase();
  return items.filter((c) => {
    if (filter) {
      const amount = primaryBalance(c.balances).amount;
      if (filter === 'owed' ? amount <= 0 : amount >= 0) return false;
    }
    return !q || peerDisplayName(c).toLocaleLowerCase().includes(q);
  });
}
